import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-signing', 'TITLE', 'Дигитальная подпись');
Labels.set(
    'ui-signing',
    'DIGIPASS_CHALLENGE',
    'Выберите в PIN-калькуляторе функцию «APPLI 2» и введите этот код:'
);
Labels.set(
    'ui-signing',
    'DIGIPASS_PASSWORD',
    'Сгенерированный PIN-калькулятором код:'
);
Labels.set('ui-signing', 'DIGIPASS_PLACEHOLDER', 'APPLI 2');
Labels.set('ui-signing', 'DIGIPASS_CONFIRM', 'Подтвердить');
Labels.set(
    'ui-signing',
    'DIGIPASS_ERROR_MESSAGE',
    'Не удалось подтвердить с помощью PIN-калькулятора.'
);

Labels.set(
    'ui-signing',
    'SMART_ID_RUNNING',
    'Подпишите с помощью Smart-ID. Сравните контрольный код!'
);
Labels.set('ui-signing', 'SMART_ID_CHALLENGE', 'Ваш контрольный код:');
Labels.set(
    'ui-signing',
    'SMART_ID_INTRO_MESSAGE',
    'Убедитесь, что Вы согласны с подписываемой информацией. Если есть сомнения, вернитесь к предыдущему шагу и проверьте содержание документа.'
);
Labels.set('ui-signing', 'SMART_ID_EXPLANATION', '');
Labels.set(
    'ui-signing',
    'SMART_ID_SENDING_MESSAGE',
    'Запрос отправлен на Ваше устройство! Сравните коды и введите PIN2.'
);

Labels.set(
    'ui-signing',
    'MOBILE_ID_RUNNING',
    'Подпишите с помощью Mobile-ID. Сравните контрольный код!'
);
Labels.set('ui-signing', 'MOBILE_ID_CHALLENGE', 'Ваш контрольный код:');
Labels.set(
    'ui-signing',
    'MOBILE_ID_INTRO_MESSAGE',
    'Убедитесь, что Вы согласны с подписываемой информацией. Если есть сомнения, вернитесь к предыдущему шагу и проверьте содержание документа.'
);
Labels.set('ui-signing', 'MOBILE_ID_EXPLANATION', '');
Labels.set(
    'ui-signing',
    'MOBILE_ID_SENDING_MESSAGE',
    'Запрос отправлен на Ваше устройство! Сравните коды и введите PIN2.'
);

Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_RUNNING',
    'Подпишите с помощью eParaksts mobile. Сравните контрольный код!'
);
Labels.set('ui-signing', 'EPARAKSTS_MOBILE_CHALLENGE', 'Ваш контрольный код:');
Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_INTRO_MESSAGE',
    'Убедитесь, что Вы согласны с подписываемой информацией. Если есть сомнения, вернитесь к предыдущему шагу и проверьте содержание документа.'
);
Labels.set('ui-signing', 'EPARAKSTS_MOBILE_EXPLANATION', '');
Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_SENDING_MESSAGE',
    'Запрос отправлен на Ваше устройство eParaksts mobile. Сравните коды и введите PIN2.'
);
Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_ERROR_MESSAGE',
    'Подписание с помощью eParaksts mobile не удалось.'
);

Labels.set(
    'ui-signing',
    'SIMPLE_ID_RUNNING',
    'Подтвердите с помощью биометрии или PIN-кода. Сравните контрольные коды!'
);
Labels.set('ui-signing', 'SIMPLE_ID_CHALLENGE', 'Ваш контрольный код:');
Labels.set(
    'ui-signing',
    'SIMPLE_ID_INTRO_MESSAGE',
    'Убедитесь, что Вы согласны с подтверждаемой информацией. Если есть сомнения, вернитесь к предыдущему шагу и проверьте содержание документа.'
);
Labels.set('ui-signing', 'SIMPLE_ID_EXPLANATION', '');
Labels.set(
    'ui-signing',
    'SIMPLE_ID_SENDING_MESSAGE',
    'Запрос отправлен на ваше смарт-устройство. Сравните контрольные коды и подтвердите с помощью биометрии или PIN-кода'
);

Labels.set('ui-signing', 'CANCEL_BUTTON_LABEL', 'Обратно');
Labels.set('ui-signing', 'CONFIRM_BUTTON_LABEL', 'Подтвердить');

Labels.set(
    'ui-signing',
    'SMART_ID_ERROR_MESSAGE',
    'Подписание с помощью Smart-ID не удалось.'
);
Labels.set(
    'ui-signing',
    'MOBILE_ID_ERROR_MESSAGE',
    'Подписание с помощью Mobile-ID не удалось.'
);
Labels.set(
    'ui-signing',
    'SIMPLE_ID_ERROR_MESSAGE',
    'Не удалось подтвердить с помощью биометрии или PIN-кода.'
);
Labels.set(
    'ui-signing',
    'CERTIFICATE_ERROR_MESSAGE',
    'Подписание с помощью ID карты не удалось.'
);

Labels.set(
    'ui-signing',
    'SMART_ID_BUTTON_LABEL',
    'Подписать с помощью PIN2 для Smart-ID'
);
Labels.set(
    'ui-signing',
    'MOBILE_ID_BUTTON_LABEL',
    'Подписать с помощью PIN2 для Mobile-ID'
);
Labels.set(
    'ui-signing',
    'EPARAKSTS_MOBILE_BUTTON_LABEL',
    'Подписать с помощью PIN2 для eParaksts mobile'
);
Labels.set(
    'ui-signing',
    'SIMPLE_ID_BUTTON_LABEL',
    'Подтвердить с помощью биометрии или PIN-кода'
);
Labels.set(
    'ui-signing',
    'CERTIFICATE_BUTTON_LABEL',
    'Подписать с помощью PIN2 для ID-карты'
);
Labels.set('ui-signing', 'DIGIPASS_BUTTON_LABEL', 'Подтвердить');

Labels.set(
    'ui-signing',
    'HWCRYPTO_DEFAULT_ERROR',
    'Плагин ID-карты не работает. Перезагрузите браузер и попробуйте снова. {{info-link}}'
);
Labels.set(
    'ui-signing',
    'HWCRYPTO_NO_CERTIFICATES',
    'Не обнаружен действующий сертификат ID-карты. Выньте ID-карту из считывателя, вставьте её обратно и попробуйте снова. {{info-link}}'
);
Labels.set(
    'ui-signing',
    'HWCRYPTO_USER_CANCEL',
    'Процесс подписания прерван, поскольку Вы нажали кнопку «Отмена».'
);
Labels.set(
    'ui-signing',
    'HWCRYPTO_DRIVER_ERROR',
    'В программном обеспечении ID-карты возникла ошибка. Проверьте, обновлено ли программное обеспечение. При необходимости обновите его, перезапустите браузер и попробуйте снова. {{info-link}}'
);
Labels.set(
    'ui-signing',
    'HWCRYPTO_NO_IMPLEMENTATION',
    'В работе плагина ID-карты возникла ошибка. Проверьте, обновлено ли программное обеспечение ID-карты и включён ли в браузере плагин «Web ID» или плагин «eParaksts signing extension». Перезагрузите браузер и попробуйте снова.'
);

Labels.set('ui-signing', 'LINK_PLACEHOLDER', 'Подробнее об ID-карте.');
